import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedComprobantesItemComponent {
  actualizando = false
  catalogos
  comprobante
  data
  editando = false
  indice = null
  leyenda = ''
  operadora
  pdf = false
  tipoGasto
  xml = false
  onChange

  constructor (ViaticosViaticoComprobanteService) {
    this.ViaticosViaticoComprobanteService = ViaticosViaticoComprobanteService
  }

  $onInit () {
    this.inicializar()
  }

  autorizar (data) {
    this.autorizando = false
    if (!data) return

    this.data = Object.assign(this.data, data)
    this.inicializar()
    this.onChange({$event: {detail: this.data}})
  }

  inicializar () {
    this.comprobante = this.data.comprobantes[0]
    this.tipoGasto = (this.catalogos.gasto_categoria.find((item) => item.ID === this.comprobante.id_categoria) || {}).Descripcion
    this.leyenda = this.data.cancelado ? 'Solicitud cancelada' :
      this.data.pagado ? 'Pago aplicado' :
        this.data.autorizado ? 'Autorizado, pendiente de pago' : 'En proceso de autorización'
    this.indice = (this.data.autorizaciones.find((autorizacion) => !autorizacion.autorizado) || {}).indice || null
    this.pdf = this.comprobante.pdf
    this.xml = this.comprobante.xml
  }

  actualizar (data) {
    if (this.actualizando) return

    this.ViaticosViaticoComprobanteService.post(data, this.comprobante.comprobante_id)
      .then(({data}) => (this.cerrar(data)))
  }

  cerrar (data) {
    this.editando = false
    if (!data) return

    this.data.comprobantes = data.comprobantes
    this.inicializar()
    this.onChange({$event: {detail: this.data}})
  }

  eliminar (data) {
    this.eliminando = false
    if (!data.eliminado) return

    this.data = null
    this.onChange({$event: {detail: this.data}})
  }
}

module.component('viaticosSharedComprobantesItem', {
  controller: ViaticosSharedComprobantesItemComponent,
  template,
  bindings: {
    catalogos: '<',
    data: '<',
    operadora: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/comprobantes/item/component.js